import _ from 'lodash';
import { createSelector } from 'reselect';

const organizationSelector = state => state.organization;

const activeCriticalExpertiseItemsSelector = (organization) => {

  const organizationData = organization.data || {};

  return _.filter(organizationData.expertiseItems || [], item => {
    return !item._deleted;
  });
}

export default createSelector(
  organizationSelector,
  activeCriticalExpertiseItemsSelector,
)



// WEBPACK FOOTER //
// ./src/selectors/activeCriticalExpertiseItemsSelector.js